import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../createPassword';
export function createPassword(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.CREATE_PASSWORD
            },
            _a[CALL_API] = {
                endpoint: "/registration/passwd",
                method: 'post',
                types: [
                    ActionTypes.SUCCESS_CREATE_PASSWORD,
                    ActionTypes.FAILURE_CREATE_PASSWORD
                ],
                data: data
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/createPassword.js